import { render, staticRenderFns } from "./index.vue?vue&type=template&id=716fa452&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716fa452')) {
      api.createRecord('716fa452', component.options)
    } else {
      api.reload('716fa452', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=716fa452&", function () {
      api.rerender('716fa452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_templates/index.vue"
export default component.exports